import BaseComponent from "../../../../../../lib/components/BaseComponent";
import {Mail} from "react-feather";
import React from "react";
import PropTypes from "prop-types";


class LogCard extends BaseComponent {
    render() {
        return <div className={'py-10 flex flex-col gap-3 border border-2 p-5 rounded-xl'}>
            <div className={'flex items-center gap-5 px-5'}>
                <h2 className={'text-cn-color-white'}>{this.props.version}</h2>
                <span className={"text-base font-thin text-cn-color-white"}>{this.props.date}</span>
            </div>
            <hr className={'border-b-2 border-cn-color-primary'}/>
            <ul className={"list-disc pl-20"}>
                {this.props.children}
            </ul>
        </div>
    }
}

LogCard.propTypes = {
    version: PropTypes.string,
    date: PropTypes.string,
}

export default LogCard;
